/** Isomorphic passwords generator (to use by backend and frontend) */
export class PasswordsGenerator {
  private static instance: PasswordsGenerator = null;

  public static getInstance(): PasswordsGenerator {
    if (!PasswordsGenerator.instance) {
      PasswordsGenerator.instance = new PasswordsGenerator();
    }
    return PasswordsGenerator.instance;
  }

  // eslint-disable-next-line @typescript-eslint/no-empty-function
  private constructor() {}

  /**
   * Generate valid password
   *
   * @returns String with random characters which can be used as password
   */
  public generatePassword = (): string => {
    const head = Math
      .random()
      .toString(36)
      .slice(-8);

    const tail = '-!@#$%^&*'
      .split('')
      .sort(() => Math.random() - 0.5)
      .join('')
      .slice(0, 2);

    return (head + tail)
      .split('')
      .sort(() => Math.random() - 0.5)
      .join('');
  };
}
